const TEXT = {
    ONBOARDING_B2B: {
        BUTTON: {
            BACK: "Tilbake",
            CONTINUE: "Fortsett",
            TELIANO_PAGE: "Tilbake til telia.no",
        },
        HEADING: "Registrering av ditt nye abonnement",
        INGRESS: (companyName: string) =>
            `${companyName} har bestilt et mobilabonnement til deg. For å fullføre bestillingen ber vi deg bekrefte identiteten din med BankID og fylle ut de resterende stegene.`,
        MISSING_ORDER_TEXT: "Ordren du prøver å finne eksisterer ikke.",
        ORDER_NOT_CORRECT_STATE: "Ordren er ikke mulig å endre, mulig den er fullført.",
        BANK_ID_VERIFIED: {
            HEADING: "Vi hentet disse opplysningene fra BankID",
            CONTINUE_DESCRIPTION: 'Trykk "Fortsett" for å gå videre eller ',
            NEW_VERIFICATION: "gjør en ny BankID verifisering",
        },
        ERROR: {
            ORDER_SUBMIT: "Beklager, noe gikk galt med din bestilling ",
        },
        CONTACT_INFORMATION: {
            HEADING: "Kontaktinformasjon",
            INGRESS: "Vi fikk dette navn fra BankID, og vi vil sette dette som bruker av abonnementet.",
            EMAIL: "E-post:",
            BUTTON: "Fortsett",
            DISCLAIMER: "E-post vil bli benyttet til å sende deg informasjon før abonnementet er aktivert.",
        },
        RECEIPT: {
            CONFIRMATION: "Velkommen som Telia-kunde!",
            ESIM: (email?: string) => `Informasjon om hvordan eSIM installeres sendes til ${email}`,
            PORTIN: (date: string) => `Mobilabonnementet ditt vil bli flyttet over til Telia ${date}.
                    I mellomtiden bruker du mobiltelefonen som vanlig med ditt gamle SIM-kort.`,
        },
    },
};

export default TEXT;
